import { render, staticRenderFns } from "./iconInfoSvg.vue?vue&type=template&id=3bf0ee6a&"
import script from "./iconInfoSvg.js?vue&type=script&lang=js&"
export * from "./iconInfoSvg.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports